/**
 * @ngInject
 */
/**
 * create store object, which is responsible for saving and getting user data - login part..
 * Store object has methods like authenticateUser, getUser and so on.. So in js code of Angular components, we call
 * flux.dispatch(actions.UPDATE_USER, formData); so we call actions.UPDATE_USER action which is calls userUpdate
 * function (store.handlers[actions.UPDATE_USER] = 'updateUser';) and in this function we call DataService (DataService.updateUser(formData))
 * to save data in the database.
 *
 *
 * @param actions - flux actions
 * @param $auth
 * @param $sessionStorage - object to save data in Session
 * @param DataService
 * @returns store object
 */
function userStore (actions, $auth, $sessionStorage, DataService) {

	function onGetUserSuccess (response) {
        // console.log("USER-STORE.jS onGetUserSuccess func", response.data);
        // $('#test').append(JSON.stringify(response.data)); // if data is comming back as JSON, we have to
		// make it to a string before we can appent it to html.

	    // Merge existing user data (if data is not from database == has no id) with whatever data the user already has client side
	    if(angular.isUndefined(store.session.user.id) && Object.keys(store.session.user).length > 0){

	    	angular.bind(this, store.updateUser(store.session.user) ); // db request will be fired but callback doesn't work due to scope confusion

	    	// Merge local data with database data
	    	angular.extend(response.data, store.session.user);
	    }

        store.session.user = response.data;
        this.state.set(['user'], response.data);
        this.state.set(['authenticated'], true);
    }
	function onGetUserError (response) {
		// console.log(response);
	}

	function onUpdateUserSuccess (response) {
        // console.log("USER-STORE.jS onUpdateUserSuccess func !!!");
        // console.log("USER-STORE.jS response.data");
        // console.log(response.data);
        // $('#test').append(response.data);

		if(angular.isUndefined(this.state)) return;

		// When we update a user, we need to read new user info from db and update all scopes.
		this.getUser();
	}
	function onUpdateUserError (response) {
		// console.log("userStore.onUpdateUserError");
		// console.log(response.data);
	}

	function onDeleteSuccess(response){
		alert("Din bruger er nu slettet.");
		store.session.user = {};
		this.state.set(['user'], {});
		$auth.logout();
	}
	function onDeleteError(response){
		alert("Der opstod en fejl. Din bruger blev ikke slettet.");
	}

	var store = {};
	store.handlers = {};
    store.handlers[actions.AUTHENTICATE_USER] = 'authenticateUser';
    store.handlers[actions.GET_USER] = 'getUser';
    store.handlers[actions.UPDATE_USER] = 'updateUser';
    store.handlers[actions.LOGOUT_USER] = 'logoutUser';
    store.handlers[actions.DELETE_USER] = 'deleteUser';

    store.session = $sessionStorage;

    if(angular.isUndefined(store.session.user)) {
    	store.session.user = {};
    }

    store.initialize = function initialize(){
		this.state = this.immutable({
			user: {},
			authenticated: false
		});	
	};

	store.authenticateUser = function authenticateUser(data){

		switch(data.type){
			case 'facebook':
				$auth.authenticate('facebook')
					.then( angular.bind(this, store.getUser) )
					.catch( angular.bind(this,function(response) {
						alert("Der opstod en fejl.");
						// console.log("facebook auth error",response);
					}));
				break;
			case 'email':
				var user = {
					email: data.email,
					password: data.password
				};
				
				$auth.login(user)
					.then( angular.bind(this, store.getUser) )
					.catch( angular.bind(this,function(response) {
						// console.log("catch: ",response);
						if(response.status === 401) {
							this.state.set(['login'], false);
						}
					}));
				break;
		}
	};

	store.getUser = function getUser(){
		DataService.getUser().then(angular.bind(this,onGetUserSuccess), angular.bind(this, onGetUserError));
	};

	store.updateUser = function updateUser(formData){
		// console.log("USER-STORE.jS updateUser func");
		// console.log("formData");
		// console.log(formData);

		if(!$auth.isAuthenticated()){
			// If user is not authenticated we only work on the client data
			if(formData) {
                angular.extend(store.session.user, formData);
				this.state.set(['user'], store.session.user );
			}
		} else {
            if(!formData) {
				formData = store.session.user;
			}
			// call updateUser func. on DataService object from services/DataService.js
			// on success call onUpdateUserSuccess func from this file
			DataService.updateUser(formData).then(angular.bind(this,onUpdateUserSuccess), angular.bind(this, onUpdateUserError));
		}

	};

	store.logoutUser = function logoutUser(){
		$auth.logout();

		store.session.user = {};
		this.state.set(['user'], {});

		window.location.href = "/";
	};

	store.deleteUser = function deleteUser() {
		DataService.deleteUser()
		    .then(angular.bind(this,onDeleteSuccess), angular.bind(this, onDeleteError));
	};

	store.exports = {};

    store.exports.getUser = function getUser () {
    	return store.session.user;
    };

	return store;

}